var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-container" },
    [
      _c("section-title", {
        staticClass: "section-container__section-title",
        attrs: {
          "container-class": _vm.sectionData.customTitle
            ? "section-container__section-title__container"
            : undefined,
          "has-line": !_vm.sectionData.customTitle,
          icon: _vm.sectionData.customTitle ? "fas fa-file-user" : undefined,
          title: _vm.sectionData.title,
          "title-class": "section-container__section-title__info"
        }
      }),
      _c(
        "div",
        { staticClass: "bg-secondary-3 p-2 row m-0 rounded" },
        [
          _c(
            "div",
            { staticClass: "col-12 col-md-6" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-date-picker", {
                          attrs: {
                            "custom-error-msg": _vm.sectionData.dateErrorMsg,
                            disabled:
                              _vm.sectionData.disabledDatePicker ||
                              _vm.readOnly,
                            error: errors[0],
                            label: _vm.sectionData.dateLabel,
                            placeholder: "DD/MM/YYYY"
                          },
                          model: {
                            value: _vm.section.date,
                            callback: function($$v) {
                              _vm.$set(_vm.section, "date", $$v)
                            },
                            expression: "section.date"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.sectionData.hasHourInput
            ? _c(
                "div",
                { staticClass: "col-12 col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-time-picker", {
                                staticClass: "custom-datetime-picker-container",
                                attrs: {
                                  "custom-error-msg":
                                    _vm.sectionData.hourErrorMsg,
                                  disabled: _vm.readOnly,
                                  error: errors[0],
                                  label: "Hora:",
                                  placeholder: "HH:mm"
                                },
                                model: {
                                  value: _vm.section.hour,
                                  callback: function($$v) {
                                    _vm.$set(_vm.section, "hour", $$v)
                                  },
                                  expression: "section.hour"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1624821961
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.section.comments, function(comment, idx) {
            return _c(
              "div",
              { key: idx, staticClass: "col-12 mt-3" },
              [
                _c("validation-provider", {
                  attrs: { rules: idx == 0 ? "required" : "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-text-area", {
                              staticClass: "section-container__text-area",
                              attrs: {
                                id: "comment",
                                "count-classes": ["d-block", "small-counter"],
                                "custom-error-msg":
                                  _vm.sectionData.textErrorMsg,
                                disabled: _vm.readOnly,
                                error: errors[0],
                                label: _vm.sectionData.textAreaLabel,
                                maxlength: 3000,
                                name: "comment",
                                "show-char-count": ""
                              },
                              model: {
                                value: _vm.section.comments[idx],
                                callback: function($$v) {
                                  _vm.$set(_vm.section.comments, idx, $$v)
                                },
                                expression: "section.comments[idx]"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm.sectionData.multipleTextArea && !_vm.readOnly
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end my-3" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-file-plus",
                  responsive: "",
                  text: "Añadir",
                  variant: "success"
                },
                on: { click: _vm.addSection }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.showSecondTextInput
        ? _c(
            "div",
            { staticClass: "bg-secondary-3 px-4 py-2 rounded" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            staticClass: "section-container__text-area",
                            attrs: {
                              id: "comment",
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": _vm.sectionData.subErrorMsg,
                              disabled: _vm.readOnly,
                              error: errors[0],
                              label: _vm.sectionData.subSectionTitle,
                              maxlength: 3000,
                              name: "comment",
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.section.subComments,
                              callback: function($$v) {
                                _vm.$set(_vm.section, "subComments", $$v)
                              },
                              expression: "section.subComments"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2165043780
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }